// extracted by mini-css-extract-plugin
export var card = "styles-module--card--1zxRO";
export var frame = "styles-module--frame--2fFw7";
export var header = "styles-module--header--3LaiA";
export var icon = "styles-module--icon--28HuV";
export var centered = "styles-module--centered--18sCb";